module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/hr/hr.component.css
// module id = ./src/app/web/game/management/business-units/hr/hr.component.css
// module chunks = main